import React from 'react';
import { ArrowRight, Phone, Network, ShieldCheck, MapPin } from 'lucide-react';
import { Button } from './ui/button';

export const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToNetwork = () => {
    const element = document.getElementById('netzwerk');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=2000&q=70"
          alt="Immobilie und Netzwerk"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-atob-blue/95 via-atob-blue/90 to-atob-blue/75"></div>
        {/* Subtle grid pattern */}
        <div
          className="absolute inset-0 opacity-[0.07]"
          style={{
            backgroundImage:
              'linear-gradient(to right, white 1px, transparent 1px), linear-gradient(to bottom, white 1px, transparent 1px)',
            backgroundSize: '60px 60px'
          }}
        ></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl">
          <div className="inline-flex items-center gap-2 bg-atob-orange/15 backdrop-blur-sm border border-atob-orange/40 rounded-full px-4 py-2 mb-7">
            <Network className="h-4 w-4 text-atob-orange" />
            <span className="text-white text-sm font-semibold uppercase tracking-wider">
              Beratung mit Netzwerk seit 2018
            </span>
          </div>

          <h1
            data-testid="hero-headline"
            className="text-4xl md:text-5xl lg:text-[4rem] font-black text-white mb-6 leading-[1.05]"
          >
            Ihre Immobilie verdient{' '}
            <span className="text-atob-orange italic font-serif">
              die richtigen Berater.
            </span>
          </h1>

          <p className="text-lg md:text-xl text-gray-200 mb-10 leading-relaxed max-w-3xl">
            Ob <span className="text-white font-semibold">Kauf, Verkauf, Finanzierung, Sanierung
            oder Verwaltung</span> – wir bringen für jede Immobilien-Frage den passenden Experten
            aus unserem geprüften Netzwerk. Ein Anruf, ein Ansprechpartner, alle Antworten.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-14">
            <Button
              size="lg"
              onClick={scrollToContact}
              data-testid="hero-primary-cta"
              className="bg-atob-orange hover:bg-atob-orange/90 text-atob-blue font-bold text-lg px-8 py-6 shadow-xl hover:shadow-2xl hover:shadow-atob-orange/30 hover:-translate-y-0.5 transition-all duration-300"
            >
              Kostenlose Erstberatung
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>

            <Button
              size="lg"
              variant="outline"
              onClick={scrollToNetwork}
              data-testid="hero-secondary-cta"
              className="bg-white/5 backdrop-blur-sm text-white border-white/40 hover:bg-white/10 hover:border-white text-lg px-8 py-6"
            >
              Netzwerk entdecken
            </Button>
          </div>

          {/* Trust indicators */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 max-w-3xl">
            <div className="flex items-center space-x-3 text-white group">
              <div className="bg-atob-orange/20 backdrop-blur-sm p-3 rounded-lg group-hover:bg-atob-orange/30 transition-all duration-300">
                <ShieldCheck className="h-6 w-6 text-atob-orange" />
              </div>
              <div>
                <p className="font-semibold">Persönlich geprüft</p>
                <p className="text-sm text-gray-300">50+ Netzwerk-Partner</p>
              </div>
            </div>

            <div className="flex items-center space-x-3 text-white group">
              <div className="bg-atob-orange/20 backdrop-blur-sm p-3 rounded-lg group-hover:bg-atob-orange/30 transition-all duration-300">
                <Phone className="h-6 w-6 text-atob-orange" />
              </div>
              <div>
                <p className="font-semibold">24h Rückmeldung</p>
                <p className="text-sm text-gray-300">Werktags garantiert</p>
              </div>
            </div>

            <div className="flex items-center space-x-3 text-white group">
              <div className="bg-atob-orange/20 backdrop-blur-sm p-3 rounded-lg group-hover:bg-atob-orange/30 transition-all duration-300">
                <MapPin className="h-6 w-6 text-atob-orange" />
              </div>
              <div>
                <p className="font-semibold">Regional verwurzelt</p>
                <p className="text-sm text-gray-300">Solingen · Langenfeld · Rheinland</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/70 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};
